import { __awaiter } from '../../_virtual/_tslib.js';
import { useQueryClient, useMutation } from 'react-query';
import { getAuthIdParam } from '../../methods/getAuthIdParam.js';
import API from '../const.js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { handleMutateResponse } from '../utils/handleMutateResponse.js';
import { QueryNames } from './queryNames.js';

function useGetDigilockerVerificationUrl() {
    const queryClient = useQueryClient();
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ companyId, redirectUrl }) => fetch(`${API.DIGILOCKER_AADHAAR_NUMBER_VERIFICATION}${getAuthIdParam()}&c_i=${companyId}&r_u=${redirectUrl}`, {
        method: "GET",
        headers: Object.assign({}, getAuthHeader())
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleGetDigilockerVerificationUrlResponse(mutateFn, aadharNumberVerificationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, aadharNumberVerificationParams);
    });
}
function handleAadharNumberVerificationResponse(mutateFn, aadharNumberVerificationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, aadharNumberVerificationParams);
    });
}
function useAadharOtpVerification() {
    const queryClient = useQueryClient();
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ aadharClientId, companyId, otp }) => fetch(`${API.VERIFY_AADHAAR_OTP}${getAuthIdParam()}`, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            company_id: Number(companyId),
            client_id: aadharClientId,
            otp: Number(otp)
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleAadharOtpVerificationResponse(mutateFn, aadharOtpVerificationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, aadharOtpVerificationParams);
    });
}
function useGstNumberVerification() {
    const queryClient = useQueryClient();
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ gstNumber, companyId }) => fetch(`${API.VERIFY_GST_NUMBER}${getAuthIdParam()}&g_n=${gstNumber}&c_i=${companyId}`, {
        method: "GET",
        headers: Object.assign({}, getAuthHeader())
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleGstNumberVerificationResponse(mutateFn, gstNumberVerificationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, gstNumberVerificationParams);
    });
}
function useGstOtpVerification() {
    const queryClient = useQueryClient();
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ gstClientId, companyId, otp }) => fetch(`${API.VERIFY_GST_OTP}${getAuthIdParam()}`, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            company_id: Number(companyId),
            client_id: gstClientId,
            otp: Number(otp)
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleGstOtpVerificationResponse(mutateFn, gstOtpVerificationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, gstOtpVerificationParams);
    });
}

export { handleAadharNumberVerificationResponse, handleAadharOtpVerificationResponse, handleGetDigilockerVerificationUrlResponse, handleGstNumberVerificationResponse, handleGstOtpVerificationResponse, useAadharOtpVerification, useGetDigilockerVerificationUrl, useGstNumberVerification, useGstOtpVerification };
//# sourceMappingURL=useKYCService.js.map
